import { getChartValueShare } from '../../../Chart'
import { BIRDVIEW_META_SEPARATOR } from '../../DashboardBirdview.constants'
import { BIRDVIEW_CHART_STACKED_SEGMENTS } from '../../DashboardBirdview.constants.charts'
import { formatBirdviewKpiValue } from '../../DashboardBirdview.utils.charts'

export function checkHasBirdviewBarsChartRowOverdue(item) {
  return item.overdue > 0
}

export function getBirdviewBarsChartSegmentStyle(value, maxValue) {
  return { width: `${getChartValueShare(value, maxValue)}%` }
}

export function getBirdviewBarsChartRowTooltipRows({
  isStacked,
  item,
  t,
  total,
  valueUnit,
  withShare,
}) {
  if (isStacked) {
    return BIRDVIEW_CHART_STACKED_SEGMENTS.map(({ color, key, labelKey }) => ({
      color,
      id: key,
      label: t(labelKey),
      value: item[key],
    }))
  }

  return [
    {
      id: item.id,
      value: withShare
        ? `${item.value}${BIRDVIEW_META_SEPARATOR}${getChartValueShare(item.value, total)}%`
        : formatBirdviewKpiValue({ t, unit: valueUnit, value: item.value }),
    },
  ]
}
